module.exports = __webpack_public_path__ + "static/img/img_t1.e42cf10a.png";